import React from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';
import CodeIcon from '@mui/icons-material/Code';
import GroupsIcon from '@mui/icons-material/Groups';
import SpeedIcon from '@mui/icons-material/Speed';
import SecurityIcon from '@mui/icons-material/Security';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import './WhyChooseUs.css';

const reasons = [
  {
    icon: <CodeIcon sx={{ fontSize: 40 }} />,
    title: 'Technical Excellence',
    description: 'Our team of expert developers stays at the forefront of technology, ensuring your project leverages the latest and most efficient solutions.'
  },
  {
    icon: <GroupsIcon sx={{ fontSize: 40 }} />,
    title: 'Dedicated Teams',
    description: 'Work with committed development teams that integrate seamlessly with your organization, understanding and delivering on your specific needs.'
  },
  {
    icon: <SpeedIcon sx={{ fontSize: 40 }} />,
    title: 'Agile Development',
    description: 'We follow agile methodologies to ensure rapid development cycles, continuous delivery, and the flexibility to adapt to changing requirements.'
  },
  {
    icon: <SecurityIcon sx={{ fontSize: 40 }} />,
    title: 'Security First',
    description: 'Your data security is our priority. We implement robust security measures and follow industry best practices in all our development processes.'
  },
  {
    icon: <SupportAgentIcon sx={{ fontSize: 40 }} />,
    title: '24/7 Support',
    description: 'Round-the-clock support ensures your systems run smoothly. Our team is always ready to address any concerns or technical issues.'
  },
  {
    icon: <IntegrationInstructionsIcon sx={{ fontSize: 40 }} />,
    title: 'Seamless Integration',
    description: 'We ensure smooth integration with your existing systems and third-party services, creating a cohesive technology ecosystem.'
  }
];

const WhyChooseUs = () => {
  return (
    <section className="sd-why-section">
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="sd-why-header"
        >
          <Typography variant="h2" className="sd-why-title">
            Why Choose Us
          </Typography>
          <Typography className="sd-why-subtitle">
            Partner with us for unparalleled software development expertise and dedicated support
          </Typography>
        </motion.div>

        <Grid container spacing={4} className="sd-why-grid">
          {reasons.map((reason, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Box className="sd-why-card">
                  <div className="sd-why-icon-wrapper">
                    {reason.icon}
                  </div>
                  <Typography variant="h6" className="sd-why-card-title">
                    {reason.title}
                  </Typography>
                  <Typography className="sd-why-card-description">
                    {reason.description}
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
};

export default WhyChooseUs; 